import { ComponentChildren } from 'preact';
import { Button } from '@components/buttons';
import { RichTextWrapper } from '@course/components/page-builder';

type PageContentProps = {
  viewMode: 'desktop' | 'mobile';
  children: ComponentChildren;
  onUndo: () => void;
  onRedo: () => void;
  onAddBlock: () => void;
};

export function PageContent({ viewMode, children, onUndo, onRedo, onAddBlock }: PageContentProps) {
  return (
    <RichTextWrapper onRedo={onRedo} onUndo={onUndo}>
      <div class={viewMode === 'mobile' ? 'bg-gray-100 px-4 py-8' : ''}>
        <section
          class={`@container ${viewMode === 'mobile' ? 'w-sm mx-auto bg-white shadow-2xl' : ''}`}
        >
          {children}
        </section>
      </div>
      <Button class="w-full bg-gray-100 p-4 hover:bg-gray-200 rounded-b-lg" onClick={onAddBlock}>
        + Add Section
      </Button>
    </RichTextWrapper>
  );
}
